import {
  ActionDropdown,
  Button
} from '@org-crowley/enterprise-react-component-library';
import { DropdownItems } from '../../contexts/HeaderContext';
import { MdFilterList, MdSort } from 'react-icons/md';
interface HeaderActionDrownProps {
  actionItems: DropdownItems[];
  variant: 'Filter' | 'Sort';
}

export function HeaderActionDropdown({
  actionItems,
  variant
}: HeaderActionDrownProps) {
  return (
    <ActionDropdown className="pr-3" items={actionItems}>
      <Button as="button" variant="secondary">
        {variant === 'Filter' ? (
          <MdFilterList size={20} />
        ) : (
          <MdSort size={20} />
        )}
        <span className="hidden sm:block sm:pl-3">{variant}</span>
      </Button>
    </ActionDropdown>
  );
}
